import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';

import { ListItem, Divider } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { get, map, forIn } from 'lodash';

import KFlatButton from 'components/KJRN/KFlatButton';
import { fetchAgreements } from 'actions/Agreements';
import styles from 'styles/TBenefits';
import TLoading from './TLoading';
import TMessage from './TMessage';

const TAgreements = () => {
  const dispatch = useDispatch();
  const {
    agreementsByID, agreementsLoading, hasError, agreementsError,
  } = useSelector(state => state.AgreementsReducer);

  useEffect(() => {
    dispatch(fetchAgreements());
  }, []);

  if (agreementsLoading) {
    return <TLoading />;
  }

  if (hasError) {
    return (
      <TMessage type="error" message="tile.error" values={{ error: get(agreementsError, 'message') }} />
    );
  }

  let res = [];
  forIn(agreementsByID, ({ label, agreements }) => {
    res = map(agreements, a => (
      <div key={`${label}${a.HrAgreementID}`}>
        <ListItem
          className="agreement-item"
          innerDivStyle={styles.link}
          primaryText={a.HrAgreementText}
          hoverColor="transparent"
          onClick={() => dispatch(push('/agreements'))}
        />
        <Divider key="div" style={styles.spacer} />
      </div>
    ));
  });

  return (
    <div style={styles.container}>
      {res}
      <KFlatButton
        style={styles.actionButton}
        onClick={() => dispatch(push('/agreements'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.holiday.goto" />}
      />
    </div>
  );
};

export default TAgreements;



// WEBPACK FOOTER //
// ./src/containers/tiles/TAgreements.js